const it = {
  nav: {
    studio: "Studio",
    servizi: "Servizi",
    portfolio: "Portfolio",
    team: "Team",
    journal: "Journal",
    studioTagline: "Studio digitale",
    contatti: "Contatti",
    parliamone: "Parliamone",
  },
  common: {
    iniziamoProgetto: "Iniziamo un progetto",
    scriviStudio: "Scrivi allo studio",
    vediServizi: "Vedi tutti i servizi",
    conosciStudio: "Conosci lo studio",
    scopriDiPiu: "Scopri di più",
  },
  footer: {
    overline: "Studio · 2026",
    headline1: "Costruiamo",
    headlineEditorial: "esperienze",
    headline2: "digitali su misura.",
    navHeading: "Naviga",
    writeHeading: "Scrivici",
    tagline:
      "Modellazione 3D · Prototipazione · Ambienti digitali · Supporto creativo.",
    rights: "Tutti i diritti riservati",
    madeWith: "Made with quiet obsession",
  },
  home: {
    hero: {
      overline: "Studio digitale · Fondato da Riccardo e Sasha",
      title1: "Diamo",
      titleEditorial: "forma",
      title2: "al vostro",
      title3: "immaginario.",
      paragraph:
        "Mysterious Stew è uno studio di due persone che unisce modellazione 3D, prototipazione e ambienti digitali in un'unica officina creativa — con una rete di collaboratori esterni per ogni esigenza.",
      cta1: "Iniziamo un progetto",
      cta2: "Cosa facciamo",
    },
    marquee: [
      "Modellazione 3D",
      "Rendering",
      "Prototipazione",
      "Ottimizzazione STL",
      "Ambienti digitali",
      "Direzione creativa",
      "Print-ready",
      "Motion",
    ],
    services: {
      overline: "Servizi · Quattro discipline",
      title1: "Un solo studio,",
      titleEditorial: "quattro materie",
      title2: "da comporre.",
      paragraph:
        "Ogni progetto viene affrontato come un pezzo unico. Selezioniamo le competenze giuste — interne o dei nostri collaboratori — per ottenere il risultato più preciso.",
      items: [
        {
          title: "Modellazione 3D",
          desc: "Sculpting hard-surface e organico. Asset pronti per render, cinema, gioco o stampa.",
        },
        {
          title: "Prototipazione & stampa 3D",
          desc: "Dal file al pezzo tangibile. Prototipi, master di produzione, edizioni limitate.",
        },
        {
          title: "Ambienti digitali",
          desc: "Set virtuali, spazi immersivi, scene fotorealistiche per storytelling e prodotto.",
        },
        {
          title: "Supporto digitale",
          desc: "Regia creativa continua: consulenza, workflow, produzione contenuti e coordinamento.",
        },
      ],
    },
    studio: {
      overline: "Lo studio · Due fondatori",
      titleRiccardo: "Riccardo",
      titleAmp: "&",
      titleSasha: "Sasha.",
      titleLine2: "Un core team,",
      titleLine3: "una rete estesa.",
      paragraph:
        "Siamo in due, ma non lavoriamo da soli. Costruiamo il team giusto per ogni progetto attivando illustratori, animatori, scultori e sviluppatori con cui collaboriamo da anni.",
      role: "Co-fondatore",
    },
    finalCta: {
      overline: "Prossimo passo",
      title1: "Avete un'idea?",
      titleEditorial: "Cuciniamola insieme.",
      button: "Scrivi allo studio",
    },
  },
  services: {
    header: {
      overline: "Servizi",
      title1: "Quattro discipline,",
      titleEditorial: "un unico linguaggio",
      titleEnd: ".",
      paragraph:
        "Non offriamo pacchetti preconfezionati. Ogni progetto viene attraversato — insieme — dal primo schizzo alla consegna finale, attivando le competenze giuste al momento giusto.",
    },
    items: [
      {
        tag: "3D",
        title: "Modellazione 3D",
        desc: "Sculpting hard-surface e organico, modellazione low-poly e high-poly. Asset pronti per rendering fotorealistici, cinema, videogiochi o stampa 3D.",
        deliverables: [
          "Modelli STL / OBJ / FBX",
          "Retopology & UV",
          "Concept-to-model iterativo",
          "Master di produzione",
        ],
      },
      {
        tag: "PRINT",
        title: "Prototipazione & stampa 3D",
        desc: "Dal file al pezzo tangibile. Preparazione supporti, ottimizzazione per resina/FDM, prototipi funzionali e serie limitate.",
        deliverables: [
          "Print-ready files",
          "Supporti & orientamento",
          "Prototipi funzionali",
          "Edizioni limitate",
        ],
      },
      {
        tag: "ENV",
        title: "Ambienti digitali",
        desc: "Set virtuali, spazi immersivi, scene fotorealistiche o stilizzate per storytelling, presentazione prodotto, esperienze interattive.",
        deliverables: [
          "Scene fotorealistiche",
          "Set virtuali",
          "Preview real-time",
          "Sequenze animate",
        ],
      },
      {
        tag: "STUDIO",
        title: "Supporto digitale",
        desc: "Regia creativa continua: consulenza, definizione workflow, produzione contenuti e coordinamento con collaboratori esterni.",
        deliverables: [
          "Direzione creativa",
          "Produzione contenuti",
          "Workflow design",
          "Team on-demand",
        ],
      },
    ],
    cta: {
      overline: "Un servizio ibrido?",
      title1: "I progetti migliori",
      title2: "nascono al",
      titleEditorial: "confine",
      titleEnd: ".",
      button: "Racconta il tuo progetto",
    },
  },
  team: {
    intro: {
      overline: "Lo studio",
      title1: "Due mani",
      titleEditorial: "tante voci",
      titleEnd: ".",
      paragraph:
        "Il core team è composto da due persone. Attorno a noi ruota una rete stabile di collaboratori esterni — illustratori, animatori, scultori, sviluppatori — che ci permette di comporre il team giusto per ogni progetto senza mai perdere in coerenza.",
    },
    founders: [
      {
        name: "Riccardo",
        role: "Co-fondatore · Scultura digitale & direzione creativa",
        badge: "Co-fondatore 01",
        bio: "Modella figure, sagome e pose. Guida l'estetica visiva dello studio e dà voce al lato più tattile e materico del nostro lavoro.",
        focus: ["Sculpting", "Character design", "Art direction"],
      },
      {
        name: "Sasha",
        role: "Co-fondatore · Hard-surface & workflow tecnico",
        badge: "Co-fondatore 02",
        bio: "Cura la componente tecnica: hard-surface, retopology, printability e la struttura dei nostri flussi di lavoro end-to-end.",
        focus: ["Hard-surface", "Printability", "Tech pipeline"],
      },
    ],
    crew: {
      overline: "La rete estesa",
      title1: "Un team che si",
      titleEditorial: "compone",
      title2: "attorno al progetto.",
      paragraph:
        "Non siamo un'agenzia con reparti fissi. Attiviamo di volta in volta i profili giusti, restando noi due la costante che garantisce direzione, qualità e continuità.",
      items: [
        { role: "Illustratori", count: "02", desc: "Concept e visual development." },
        { role: "Animatori", count: "02", desc: "Motion e sequenze animate." },
        { role: "Scultori", count: "03", desc: "Rifiniture e specialty pieces." },
        { role: "Sviluppatori", count: "02", desc: "Backend e integrazioni web." },
      ],
    },
    manifesto: {
      overline: "Il nostro modo",
      quote:
        "\u201CPreferiamo pochi progetti fatti con attenzione ossessiva, piuttosto che tanti fatti in fretta.\u201D",
      button: "Lavora con noi",
    },
  },
  portfolio: {
    header: {
      overline: "Portfolio · Selezione",
      title1: "Progetti,",
      titleEditorial: "non prodotti",
      titleEnd: ".",
      paragraph:
        "Una selezione delle collaborazioni recenti dello studio, tra modellazione, ambienti digitali e prototipi per la stampa 3D.",
    },
    projects: [
      {
        id: "obsidian-vault",
        title: "Obsidian Vault",
        tag: "Ambiente digitale",
        desc: "Ambiente immersivo per un lancio prodotto di lusso: modellazione, lighting e post-produzione.",
      },
      {
        id: "forma-01",
        title: "Forma 01",
        tag: "Modellazione 3D",
        desc: "Serie di sculture digitali astratte per collezione limitata.",
      },
      {
        id: "corpo-solido",
        title: "Corpo Solido",
        tag: "Prototipazione",
        desc: "Prototipazione rapida di un componente meccanico. Iterazione dal file al pezzo finito.",
      },
      {
        id: "vitrea",
        title: "Vitrea",
        tag: "Ambiente digitale",
        desc: "Set virtuale per una campagna editoriale di brand accessori.",
      },
      {
        id: "atelier-site",
        title: "Atelier — sito editoriale",
        tag: "Sito internet",
        desc: "Sito su misura per uno studio d'arte contemporanea. Design, sviluppo e CMS.",
      },
      {
        id: "collettivo",
        title: "Collettivo",
        tag: "Supporto creativo",
        desc: "Consulenza continua per un collettivo di artisti: workflow e produzione contenuti.",
      },
    ],
    cta: {
      overline: "Un progetto simile?",
      title1: "Ogni progetto ha",
      title2: "la sua",
      titleEditorial: "domanda giusta",
      titleEnd: ".",
      button: "Iniziamo a parlare",
    },
  },
  journal: {
    header: {
      overline: "Journal · Note dallo studio",
      title1: "Appunti,",
      titleEditorial: "non tutorial",
      titleEnd: ".",
      paragraph:
        "Pensieri, dietro le quinte e riflessioni sul mestiere. Aggiorniamo il journal quando abbiamo qualcosa che vale la pena scrivere — mai per riempire il calendario.",
    },
    tags: [
      "3D",
      "Modellazione",
      "Print",
      "Studio Notes",
      "Workflow",
      "Direzione creativa",
      "Ambienti",
      "Collaborazioni",
    ],
    readTimeLabel: "Lettura",
    readTimeUnit: "min",
    backLabel: "Torna al journal",
    moreLabel: "Altri appunti",
    entries: [
      {
        slug: "superficie-e-luce",
        date: "12 · 02 · 2026",
        tag: "Studio note",
        title: "Come pensiamo la modellazione 3D di lusso",
        excerpt:
          "Un promemoria interno diventato appunto pubblico: perché la nostra ossessione per la superficie ha molto meno a che fare con il lucido, e molto di più con la luce.",
        readTime: "6",
        intro:
          "Questo appunto nasce da una conversazione interna allo studio, davanti a un render che non ci convinceva. Il modello era tecnicamente impeccabile, eppure sembrava… economico. Da lì è partita una riflessione su cosa renda davvero «di lusso» un oggetto digitale.",
        sections: [
          {
            h: "La superficie non è lucidatura",
            p: "Quando si parla di modellazione di alta gamma, l'istinto è aggiungere: più poligoni, più riflessi, più dettaglio. Noi abbiamo imparato a fare il contrario. Una superficie di lusso è una superficie controllata — curvature continue, transizioni pulite, nessuna imperfezione accidentale. Il dettaglio c'è solo dove serve, e ogni smusso ha un raggio pensato.",
          },
          {
            h: "È la luce a raccontare la forma",
            p: "Un modello si giudica muovendo una luce sopra la sua superficie. Se i riflessi scorrono senza rotture, la forma è risolta; se si spezzano, nessun materiale potrà salvarla. Per questo passiamo più tempo sulle curvature che sulle texture: la percezione di qualità nasce lì, molto prima del rendering finale.",
          },
          {
            h: "Cosa cambia per chi ci commissiona un lavoro",
            p: "Significa che nei nostri preventivi c'è una voce invisibile: il tempo dedicato a ciò che non si vede al primo sguardo ma si percepisce sempre. È la differenza tra un oggetto digitale che «funziona» e uno che sembra vero, prezioso, desiderabile. È il motivo per cui i nostri clienti tornano.",
          },
        ],
      },
      {
        slug: "anatomia-prototipo",
        date: "24 · 01 · 2026",
        tag: "Workflow",
        title: "Dallo schizzo al print — anatomia di un prototipo",
        excerpt:
          "Ripercorriamo un progetto recente per raccontare come uniamo modellazione, retopology e stampa 3D quando ogni millimetro conta.",
        readTime: "9",
        intro:
          "Un componente meccanico, tolleranze strette e un cliente con una scadenza vera. Ripercorriamo le tappe di un progetto recente per mostrare come lavoriamo quando il file deve diventare un oggetto fisico.",
        sections: [
          {
            h: "Il primo schizzo è già ingegneria",
            p: "Ogni prototipo inizia su carta, ma con vincoli chiari fin dal primo tratto: dimensioni reali, punti di stress, direzione di stampa. Disegnare senza pensare alla produzione significa dover ridisegnare dopo. Nel nostro flusso, forma e fattibilità nascono insieme.",
          },
          {
            h: "Retopology: dove si vincono i millimetri",
            p: "Il passaggio dal modello scultoreo alla mesh di produzione è la fase più silenziosa e più critica. Pareti con spessori minimi garantiti, geometrie chiuse, superfici verificate. Sasha controlla ogni zona critica con sezioni trasversali: quando un pezzo deve incastrarsi in un altro, il margine di errore è zero.",
          },
          {
            h: "La stampa è una verifica, non un traguardo",
            p: "Il primo pezzo stampato non è mai quello finale. Serve per misurare, montare, capire dove la realtà si discosta dal file. In questo progetto sono servite tre iterazioni: la terza si incastrava con uno scatto netto, senza gioco. È quel suono — un click preciso — il vero deliverable.",
          },
        ],
      },
      {
        slug: "manifesto-pacchetti",
        date: "08 · 01 · 2026",
        tag: "Journal",
        title: "Un manifesto piccolo, contro i pacchetti preconfezionati",
        excerpt:
          "Ogni progetto è un problema diverso. Ecco perché non offriamo listini standard e come questa scelta cambia il modo di lavorare con noi.",
        readTime: "4",
        intro:
          "Ci viene chiesto spesso: «Quanto costa un modello 3D? E un ambiente digitale?». La risposta onesta è: dipende. Questo piccolo manifesto spiega perché non abbiamo un listino, e perché crediamo che sia un vantaggio per chi lavora con noi.",
        sections: [
          {
            h: "Ogni progetto è una domanda diversa",
            p: "Un pacchetto preconfezionato presuppone che tutti i problemi si somiglino. La nostra esperienza dice il contrario: la stessa richiesta — «un modello per la stampa» — può richiedere tre giorni o tre settimane a seconda di uso, materiale e livello di finitura. Prezzare prima di capire significa prezzare male.",
          },
          {
            h: "Il preventivo come primo atto di progetto",
            p: "Per noi il preventivo non è un numero: è la prima bozza del progetto. Contiene le fasi, le iterazioni previste, cosa è incluso e cosa consigliamo di rimandare. Un cliente che legge il nostro preventivo sa già come lavoreremo insieme, prima ancora di firmare.",
          },
          {
            h: "Meno progetti, fatti meglio",
            p: "Rifiutare la logica dei pacchetti ci obbliga a scegliere: prendiamo solo i progetti a cui possiamo dedicare attenzione vera. È una scelta commercialmente controcorrente, ma è il motivo per cui ogni lavoro che esce dallo studio porta la stessa cura, dal primo all'ultimo pixel.",
          },
        ],
      },
      {
        slug: "rete-estesa",
        date: "22 · 12 · 2025",
        tag: "Collaborazioni",
        title: "La rete estesa: chi c'è dietro ogni progetto",
        excerpt:
          "Illustratori, animatori, scultori. Le persone che ruotano attorno al core team e come vengono scelte per ogni commessa.",
        readTime: "5",
        intro:
          "Sul sito scriviamo «core team di due persone, rete estesa di collaboratori». Ma cosa significa in pratica? Chi tocca davvero i vostri progetti, e come scegliamo con chi lavorare?",
        sections: [
          {
            h: "Due persone come punto fermo",
            p: "Riccardo e Sasha seguono ogni progetto dall'inizio alla fine: direzione creativa, rapporto con il cliente, controllo qualità. Nulla esce dallo studio senza essere passato dalle nostre mani. Questo garantisce coerenza — lo stesso standard, la stessa voce, su ogni consegna.",
          },
          {
            h: "Come scegliamo i collaboratori",
            p: "La rete estesa non è un elenco di freelance trovati al bisogno: sono professionisti con cui lavoriamo da anni — illustratori, animatori, scultori, sviluppatori. Ognuno è stato scelto dopo progetti reali, non colloqui. Se un nome è nella nostra rete, è perché ha già dimostrato di reggere il nostro standard.",
          },
          {
            h: "Il vantaggio per il cliente",
            p: "Questo modello unisce il meglio di due mondi: la cura e la responsabilità diretta di uno studio piccolo, con la capacità produttiva di una squadra più grande. Il cliente parla sempre con noi due, ma dietro ogni progetto si compone il team esatto che quella commessa richiede.",
          },
        ],
      },
    ],
    cta: {
      overline: "Restiamo in contatto",
      title1: "Poche note,",
      titleEditorial: "quando servono",
      titleEnd: ".",
      button: "Scrivici per collaborazioni",
    },
  },
  contact: {
    header: {
      overline: "Contatti",
      title1: "Iniziamo",
      title2: "a",
      titleEditorial: "parlarne",
      titleEnd: ".",
      paragraph:
        "Un progetto in mente, un'idea da esplorare, una domanda? Scrivici con calma. Riccardo e Sasha rispondono personalmente entro pochi giorni.",
    },
    form: {
      nameLabel: "Nome",
      namePlaceholder: "Come ti chiami?",
      emailLabel: "Email",
      emailPlaceholder: "tua@email.com",
      subjectLabel: "Su cosa lavoriamo?",
      messageLabel: "Messaggio",
      messagePlaceholder: "Raccontaci il progetto, l'idea, la scadenza…",
      hint: "Rispondiamo personalmente, di solito entro 3 giorni lavorativi.",
      submit: "Invia messaggio",
      submitting: "Invio in corso…",
      validationError: "Compila nome, email e messaggio.",
      sendError: "Errore nell'invio. Riprova tra poco.",
      successToast: "Messaggio inviato — ti risponderemo presto.",
    },
    services: [
      "Modellazione 3D",
      "Prototipazione & stampa 3D",
      "Ambienti digitali",
      "Supporto digitale",
      "Altro",
    ],
    wizard: {
      stepWord: "Passo",
      ofWord: "di",
      step1Title: "Su cosa lavoriamo?",
      step2Title: "Che budget hai in mente?",
      step2Hint: "Una stima serve solo a orientare la proposta — nessun vincolo.",
      budgetOptions: ["Meno di 500 €", "500 – 1.500 €", "1.500 – 5.000 €", "Oltre 5.000 €", "Da definire insieme"],
      step3Title: "Quando ti serve?",
      timelineOptions: ["Urgente (entro 2 settimane)", "Entro 1 mese", "1 – 3 mesi", "Flessibile"],
      step4Title: "Raccontaci il progetto",
      step5Title: "I tuoi contatti",
      summaryTitle: "Riepilogo della richiesta",
      next: "Avanti",
      back: "Indietro",
      selectHint: "Seleziona un'opzione per continuare",
    },
    thanks: {
      overline: "Ricevuto",
      title1: "Grazie —",
      titleEditorial: "torniamo presto",
      titleEnd: ".",
      paragraph:
        "Il tuo messaggio è arrivato allo studio. Ti risponderemo di persona entro pochi giorni lavorativi.",
      again: "Scrivi un altro messaggio",
    },
    info: {
      emailTitle: "Email diretta",
      emailNote:
        "Per collaborazioni, richieste stampa o preventivi. Rispondiamo di persona.",
      whereTitle: "Dove siamo",
      whereValue: "Italia",
      whereNote: "Studio remoto · lavoriamo con clienti in Europa e oltre.",
      timeTitle: "Tempi di risposta",
      timeValue: "3 giorni lavorativi",
      timeNote: "Rispondiamo a ogni messaggio, uno alla volta.",
    },
  },
  seo: {
    home: {
      title: "Mysterious Stew — Studio digitale · 3D, stampa e ambienti digitali",
      description:
        "Studio digitale di Riccardo e Sasha: modellazione 3D, prototipazione e stampa 3D, ambienti digitali e supporto creativo su misura.",
    },
    servizi: {
      title: "Servizi — Modellazione 3D, stampa 3D e ambienti digitali · Mysterious Stew",
      description:
        "Quattro discipline, un unico linguaggio: modellazione 3D, prototipazione e stampa 3D, ambienti digitali e supporto digitale continuo.",
    },
    team: {
      title: "Lo studio — Riccardo & Sasha · Mysterious Stew",
      description:
        "Due fondatori, una rete estesa di collaboratori: illustratori, animatori, scultori e sviluppatori che si compongono attorno a ogni progetto.",
    },
    journal: {
      title: "Journal — Note dallo studio · Mysterious Stew",
      description:
        "Appunti, dietro le quinte e riflessioni sul mestiere: modellazione 3D, workflow di stampa, direzione creativa.",
    },
    contatti: {
      title: "Contatti — Iniziamo un progetto · Mysterious Stew",
      description:
        "Raccontaci il tuo progetto: modellazione 3D, prototipazione, ambienti digitali o supporto creativo. Rispondiamo personalmente entro 3 giorni.",
    },
  },
  mmf: {
    views: "Visualizzazioni",
    likes: "Mi piace",
    followers: "Follower",
    models: "Modelli pubblicati",
    visit: "Vedi tutto su MyMiniFactory",
    collectionsLabel: "Le nostre fazioni",
    viewerLabel: "Anteprima 3D",
    viewerTitle: "Toccalo",
    viewerTitleEditorial: "con mano.",
    viewerHint: "Trascina per ruotare",
    viewerLoading: "Caricamento modello…",
    featuredLabel: "Modelli in evidenza",
  },
  language: {
    label: "Lingua",
  },
};

export default it;
